import { computed, Injectable, inject } from '@angular/core';
import { AccountsHashmapState } from '../accounts/accounts-hashmap.state';
import { ActiveTaskDetailsProviderService } from '../../../../../shared/state/combined-state/active-task-details.provider.service';
import { CreatePackageTaskDetailsUi } from '../../../../../../routes-with-sidebar/shared/models/task-details.model';

@Injectable({
  providedIn: 'root',
})
export class ActiveAccountProviderService {
  private readonly activeTaskDetailsProviderService = inject<
    ActiveTaskDetailsProviderService<CreatePackageTaskDetailsUi>
  >(ActiveTaskDetailsProviderService);
  private readonly accountsHashmapState = inject(AccountsHashmapState);

  public readonly activeAccountManager = computed(() => {
    const activeTaskDetails =
      this.activeTaskDetailsProviderService.activeTaskDetails();

    if (!activeTaskDetails || !activeTaskDetails.accountId) {
      return null;
    }
    return this.accountsHashmapState.getState(activeTaskDetails.accountId);
  });

  public activeAccount = computed(() => {
    const activeAccountManager = this.activeAccountManager();
    if (!activeAccountManager) {
      return null;
    }

    return activeAccountManager.account();
  });

  public readonly loading = computed(() => {
    const activeAccountManager = this.activeAccountManager();

    if (!activeAccountManager) {
      return null;
    }

    return activeAccountManager.loading();
  });

  public readonly error = computed(() => {
    const activeAccountManager = this.activeAccountManager();

    if (!activeAccountManager) {
      return null;
    }

    return activeAccountManager.error();
  });
}
